import { Data, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { reaction } from 'mobx';
import { AppService, Types } from '../../../App/Services/AppService';
import ManageExclusionAccountsComponentVM from '../Components/ManageExclusionAccountsComponentVM';
import ExcludedAccountLookup from '../Models/Lookups/ExcludedAccountLookup';
import ExcludedAccountSearchCriteria from '../Models/Queries/ExcludedAccountSearchCriteria';

@NeoModel
export default class ExcludedAccountsVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public clientAccountApiClient = AppService.get(Types.ApiClients.ClientAccountApiClient),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService)) {
        super(taskRunner);
    }

    public excludedAccountSearchCriteria = new ExcludedAccountSearchCriteria();
    public manageExclusionAccountComponentVM = new ManageExclusionAccountsComponentVM();
    public showManageExcludedAccountComponent: boolean = false;

    public pageManager = new Data.PageManager(this.excludedAccountSearchCriteria, ExcludedAccountLookup,
        this.clientAccountApiClient.getPagedExcludedAccounts, {
        pageSize: 10,
        sortAscending: true,
        fetchInitial: true,
        sortBy: "accountNumber",
        initialTaskRunner: this.taskRunner,
    });

    public async initialise() {
        reaction(() => this.excludedAccountSearchCriteria.searchCriteria, () => this.pageManager.refreshData(), { fireImmediately: false, delay: 650 });
    }

    public async addNewExclusionAccount() {
        this.showManageExcludedAccountComponent = true;
        this.manageExclusionAccountComponentVM.managedExclusionAccount = new ExcludedAccountLookup();
    }

    public cancel() {
        this.manageExclusionAccountComponentVM.managedExclusionAccount = new ExcludedAccountLookup();
        this.showManageExcludedAccountComponent = false;
    }

    public async clearSearch() {
        this.excludedAccountSearchCriteria.meta.searchCriteria.value = "";
        await this.pageManager.refreshData();
    }
}